// extracted by mini-css-extract-plugin
export default {"root":"ChapterHeader_root__UCMsp","title":"ChapterHeader_title__TjczJ"};